module.exports = __webpack_public_path__ + "static/Dia-Regular-5d970ed7352325617f6093cc3bb13e50.eot";